import React from "react";
import * as S from "./styles";

const CheckIcon = () => (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 5L4.3 8.3L11 1" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Checkbox custom (quadrado verde com check branco quando marcado). Se
// vier dentro de uma linha que já trata o clique (ex.: uma opção de lista
// inteira clicável), não passe onChange - ele fica só decorativo e o
// clique segue borbulhando pro elemento pai normalmente. Se `onChange` for
// passado, o próprio checkbox vira o alvo do clique (com stopPropagation).
const Checkbox = ({ checked = false, onChange, disabled = false, ...props }) => {
    const handleClick = (e) => {
        if (disabled || !onChange) return;
        e.stopPropagation();
        onChange(!checked);
    };

    return (
        <S.Checkbox
            type="button"
            role="checkbox"
            aria-checked={checked}
            checked={checked}
            disabled={disabled}
            onClick={handleClick}
            {...props}
        >
            {checked && <CheckIcon />}
        </S.Checkbox>
    );
};

export default Checkbox;
